// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC0IUbkv1QE_rrW-jy3HDzWEpJijd5i-Po",
  authDomain: "open-meta-crypto.firebaseapp.com",
  projectId: "open-meta-crypto",
  storageBucket: "open-meta-crypto.appspot.com",
  messagingSenderId: "932956288660",
  appId: "1:932956288660:web:c2074f018f3b3b4230a681",
};

export default firebaseConfig;
